<template>
  <div
    v-if="show"
    class="bg-gray-900 text-white py-2 px-4"
  >
    <div class="flex items-center justify-between min-w-0">
      <!-- Navigation Buttons & Rotating Announcements -->
      <div class="flex items-center gap-2 flex-1 min-w-0 mx-auto" style="max-width: 480px">
        <!-- Previous Button -->
        <UButton
          v-if="announcements.length > 1"
          variant="link"
          size="xs"
          icon="i-heroicons-chevron-left"
          aria-label="Previous announcement"
          class="text-white hover:text-gray-300"
          :class="{
            'opacity-50': announcements.length == 2 && activeIndex === 0,
            'cursor-pointer': announcements.length > 2 || activeIndex > 0
          }"
          @click="prev"
        />

        <!-- Announcements Carousel -->
        <div class="flex-1 min-w-0">
          <UCarousel
            ref="carousel"
            v-slot="{ item }"
            :items="announcements"
            :ui="{
              item: 'basis-full',
              container: 'gap-0 items-center'
            }"
            class="overflow-hidden"
            @select="updateActiveIndex"
            :loop="announcements.length > 2"
          >
            <div class="text-sm text-center px-2 ">
              {{ item.emoji }} {{ item.text }}
              <span v-if="item.subtext" class="hidden sm:inline">
                {{ item.subtext }}
              </span>
            </div>
          </UCarousel>
        </div>

        <!-- Next Button -->
        <UButton
         v-if="announcements.length > 1"
          variant="link"
          size="xs"
          icon="i-heroicons-chevron-right"
          aria-label="Next announcement"
          class="text-white hover:text-gray-300"
          :class="{
            'opacity-50': announcements.length == 2 && activeIndex === announcements.length - 1,
            'cursor-pointer': announcements.length > 2 || activeIndex < announcements.length -1
          }"
          @click="next"
        />
      </div>

      <!-- Close Button -->
      <UButton
        variant="link"
        size="xs"
        icon="i-heroicons-x-mark"
        aria-label="Close topbar"
        class="ml-3 md:ml-4 text-white hover:text-gray-300 cursor-pointer"
        @click="show = false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Announcement {
  emoji: string
  text: string
  subtext?: string
}

withDefaults(
  defineProps<{
    announcements?: Announcement[]
    initialShow?: boolean
  }>(),
  {
    announcements: () => [
      {
        emoji: '🎉',
        text: 'Free Shipping on orders over $250.',
        subtext: "Don't miss a discount! Test it now.fasdfasdfasdf",
      },
      {
        emoji: '💰',
        text: 'Money back guarantee.',
        subtext: 'We return money within 30 days.',
      },
      {
        emoji: '💪',
        text: 'Friendly 24/7 customer support.',
        subtext: "We've got you covered!",
      },
    ],
    initialShow: true,
  }
)

const show = useCookie('topbar-visible', {
  default: () => true,
  maxAge: 60 * 60 * 24 * 1 // 1 day off
})

const carousel = useTemplateRef('carousel')

const activeIndex = ref(0)

const updateActiveIndex = (selectedIndex : number) => {
  activeIndex.value = selectedIndex
}

const prev = () => {
   carousel.value?.emblaApi?.scrollTo(activeIndex.value - 1)
}

const next = () => {
  carousel.value?.emblaApi?.scrollTo(activeIndex.value + 1)
}
</script>
